<template>
  <div>
    <DesignCollapseTemplate collapseId="rewards" class="mb-3"
      :collapseContentClass="campaignData.design.milestones.length > 0 ? 'mt-5' : 'mt-3'">
      <template slot="header">Rewards</template>
      <template slot="content">
        <div v-for="(reward, index) in campaignData.design.milestones" :key="`campaign-reward-item-${index}`">
          <RewardItemTemplate :campaignRewardIndex="index"
            :class="['mb-3', { 'margin-bottom-with-offset': index < campaignData.design.milestones.length - 1 }]">
            <template slot="label">{{ reward.milestone_label }}</template>
            <template slot="name">
              <span class="font-weight-bold">{{ `Free ${reward.reward.name ? reward.reward.name : ''}` }}</span>
              <span v-if="!reward.is_main">{{ ` after ${reward.is_main ? campaignData.design.number_of_stamps : reward.stamps_count} stamps` }}</span>
            </template>
            <template slot="expiry">No expiry</template>
          </RewardItemTemplate>
        </div>
        <b-button v-if="!hasReachedMaxReward" id="button-punch-card-campaign-add-reward" variant="outline-primary"
          class="w-100 bg-transparent text-center"
          @click="$root.$emit('bv::show::modal', 'modal-punch-card-campaign-reward-modal')">
          + Add Reward
        </b-button>
        <b-form-invalid-feedback :force-show="$v.rewards.$errors.length > 0 || !!apiErrors.milestones">
          <template v-if="!!apiErrors.milestones">{{ apiErrors.milestones }}</template>
          <p v-else class="mb-0" v-for="error in $v.rewards.$errors" :key="error.$uid">{{ error.$message }}</p>
        </b-form-invalid-feedback>
      </template>
    </DesignCollapseTemplate>
    <PunchCardRewardModal :source="source" :key="source" />
  </div>
</template>

<script>
import { computed, defineComponent, getCurrentInstance, onBeforeUnmount, onMounted } from "@vue/composition-api";
import DesignCollapseTemplate from "./DesignCollapseTemplate.vue";
import PunchCardRewardModal from "./PunchCardRewardModal.vue";
import RewardItemTemplate from "./RewardItemTemplate.vue";
import { mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import { fieldRequiredErrorMessage } from "../../punch.card.utilities";

export default defineComponent({
  props: {
    source: {
      type: String,
      default: "create"
    }
  },
  components: { DesignCollapseTemplate, PunchCardRewardModal, RewardItemTemplate },
  computed: {
    ...mapState("punchCard", ["campaignData"])
  },
  mounted() {
    this.$root.$on("bv::hide::modal", (modalId) => {
      if (modalId === "modal-punch-card-campaign-reward-modal") this.$forceUpdate();
    });
  },
  setup(_, { root }) {
    const currentInstance = getCurrentInstance();

    const form = {
      rewards: computed(() => currentInstance.proxy.campaignData.design.milestones || [])
    };

    const rules = computed(() => ({
      rewards: {
        required: helpers.withMessage(fieldRequiredErrorMessage, required),
        mainRewardRequired: helpers.withMessage("Main reward is required.", () => !helpers.req(form.rewards.value) || hasMainReward.value)
      }
    }));

    const $v = useVuelidate(rules, form);

    onMounted(() => {
      root.$on("validateForm", () => {
        $v.value.$touch();

        if (
          $v.value.$dirty &&
          $v.value.$invalid &&
          currentInstance.proxy.campaignData.active === "design"
        ) {
          currentInstance.proxy.campaignData.designVisibility.rewards = true;
        }
      });
    });

    onBeforeUnmount(() => root.$off("validateForm"));

    const apiErrors = computed(() => root.$store.state.punchCard.errors || {});

    const hasReachedMaxReward = computed(() => root.$store.state.punchCard.campaignData.design.milestones.length === Number(root.$store.state.punchCard.campaignData.design.number_of_stamps));

    const hasMainReward = computed(() => currentInstance.proxy.campaignData.design.milestones.map(({ is_main }) => is_main).reduce((res, cur) => res || cur, false));

    return {
      $v,
      apiErrors,
      hasReachedMaxReward
    }
  }
});
</script>

<style lang="scss" scoped>
#button-punch-card-campaign-add-reward {
  height: 44px;
  border-radius: 5px;
  font-family: MainFontBold, sans-serif;
  font-size: 14px;
}

.margin-bottom-with-offset {
  margin-bottom: 2.25rem !important;
}
</style>

<style lang="scss">
#button-punch-card-campaign-add-reward {
  border-style: dashed;
}
</style>
